import React from 'react';
import Breadcrumbs from '../../elements/Breadcrumbs';
import { Button, ButtonsContainer } from './Referral.style';

const Referral = ({
  hanleSelectIsReferral,
}) => {

  return (
    <>
      <Breadcrumbs pathArr={[{ label: 'Запись на прием' }, { label: 'Направление' }]} />
      <ButtonsContainer>
        <Button onClick={() => hanleSelectIsReferral(true)}>
          Запись по направлению ф.057/у-04
        </Button>
        <Button onClick={() => hanleSelectIsReferral(false)}>
          Запись по наличному расчету
        </Button>
      </ButtonsContainer>
    </>
  )
}

export default Referral;
